import { render, staticRenderFns } from "./ServicesTypesCard.vue?vue&type=template&id=79101add&"
import script from "./ServicesTypesCard.vue?vue&type=script&lang=ts&"
export * from "./ServicesTypesCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports